import { ColumnDef } from "@tanstack/react-table";
import {IconButton} from "@nike/eds";
import { DeclarationPeriod } from "../../shared/Types";
import {ExternalLink} from "@nike/nike-design-system-icons";
import { StatusFilterOption } from "../filing_packs_table/FilingPacksTableColumns";

export type DeclarationPeriodTableColumn<T> = ColumnDef<T, any> & {
    header: string | React.ReactNode | (() => React.ReactNode);
    accessorKey?: keyof T | string;
    filterLabel?: string;
    filterType?: "select" | "text" | "date" | "dateRange" | "monthRange" | "month";
    filterOptions?: Array<{ value: string; label: string }>;
    getFilterOptions?: (tableState: any) => Array<{ value: string; label: string }>;
    enableHiding?: boolean;
    enableSorting?: boolean;
    filterKey?: string;
    filterGroup?: string;
};

export const getDeclarationPeriodTableColumns = (
    statusOptions: StatusFilterOption[] = [],
): DeclarationPeriodTableColumn<DeclarationPeriod>[] => [
    {
        header: () => (<span title="Declaration Period">Declaration Period</span>),
        accessorKey: "declarationPeriod",
        size: 200,
        enableSorting: true,
        enableColumnFilter: true,
        filterLabel: "Declaration Period",
        filterType: "month",
        filterGroup: "Declaration Period",
    },
    {
        header: () => (<span title="Filing Pack Created">Filing Pack Created</span>),
        accessorKey: "filingPacksCreated",
        size: 170,
        enableSorting: true,
        enableColumnFilter: false,
    },
    {
        header: () => (<span title="Filing Pack Accepted">Filing Pack Accepted</span>),
        accessorKey: "filingPacksAccepted",
        size: 170,
        enableSorting: true,
        enableColumnFilter: false,
    },
    {
        header: () => (<span title="Filing Pack Released">Filing Pack Released</span>),
        accessorKey: "filingPacksReleased",
        size: 170,
        enableSorting: true,
        enableColumnFilter: false,
    },
    {
        header: () => (<span title="Declaration Id">Declaration Id</span>),
        accessorKey: "declarationId",
        enableSorting: false,
        enableColumnFilter: true,
        filterLabel: "Declaration Id",
        filterType: "text",
        filterGroup: "Declaration Period Event",
    },
    {
        header: () => (<span title="Status">Status</span>),
        accessorKey: "status",
        size: 170,
        enableSorting: true,
        enableColumnFilter: true,
        filterLabel: "Status",
        filterType: "select",
        filterGroup: "Declaration Period",
        filterOptions: statusOptions,
    },
    {
        header: () => (<span title="Local Reference Number">LRN</span>),
        accessorKey: "lrn",
        enableSorting: false,
        enableColumnFilter: true,
        filterLabel: "LRN",
        filterType: "text",
        filterGroup: "Declaration Period Event",
    },
    {
        header: () => (<span title="Movement Reference Number">MRN</span>),
        accessorKey: "mrn",
        enableSorting: false,
        enableColumnFilter: true,
        filterLabel: "MRN",
        filterType: "text",
        filterGroup: "Declaration Period Event",
    },
    {
        header: () => (<span title="View Filing Packs">View Filing Packs</span>),
        id: "detail-view-filing-packs",
        cell: ({row}) => (
            <IconButton
                icon={<ExternalLink/>}
                label="View filing packs"
                size="small"
                variant="ghost"
                onClick={() => {
                    window.history.pushState(null, '', `/local-clearance/filing-packs?period=${row.original.declarationPeriod}`);
                    window.dispatchEvent(new PopStateEvent('popstate'));
                }}
            />
        ),
        size: 75,
        enableSorting: false,
        enableColumnFilter: false,
    },
];
